export function onlyNumber(event: any, length: number): any {
    const { value } = event.target;
    const regexOnlyNumber = new RegExp("[0-9]{0,"+length+"}");
    const onlyNumber = value.match(regexOnlyNumber);
    const numericValue = onlyNumber[0];
    return numericValue
}

export function emailFormat(email: string): boolean {
    const re = new RegExp("^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\\.)+[a-zA-Z0-9](?:[a-z0-9-]*[a-z0-9])?$");
    return re.test(email)
}

export function exactLength(numericValue: number, length: number): boolean {
    if( numericValue === length ) {
        return true 
    } else {
        return false 
    }
}

export function lengthBetween(numericValue: number, minLength: number, maxLength: number): boolean {
    if( numericValue <= maxLength && numericValue >= minLength ) {
        return true 
    } else {
        return false 
    }
}

export function maxLength(numericValue: number, maxLength: number): boolean {
    if( numericValue > maxLength ) {
        return true 
    } else {
        return false 
    }
}

export function lowerCaseChar(text: string): boolean {
    const lower_case_char = /^(?=.*[a-z]).*$/;
    return lower_case_char.test(text)
}

export function upperCaseChar(text: string): boolean {
    const upper_case_char = /^(?=.*[A-Z]).*$/;
    return upper_case_char.test(text)
}

export function numberChar(text: string): boolean {
    const number_char = /(?=.*[0-9])/;
    return number_char.test(text)
}

export function specialChar(text: string): boolean {
    const special_char = /^(?=.*?[#?!@$%^&*-]).*$/;
    return special_char.test(text)
}

export function noConsecutiveDigits(text: string): boolean {
    const no_consecutive_digits = /^(?!.*(\d)\1).*$/;
    return no_consecutive_digits.test(text)
}

        
        